import hasPermission, { AccessArea, AccessRight } from '@/features/users/has-permission'

type ProjectAbilities = 'create'

type AllAbilities = `projects:${ProjectAbilities}`

const abilityMap: { [k in AllAbilities]: (permissions: string[]) => (boolean|undefined) } = {
  'projects:create': x => hasPermission(x, AccessArea.Project, AccessRight.Basic) || hasPermission(x, AccessArea.Administrator),
}

export default function hasAbility(permissions: string[], ability: AllAbilities) {
  const fn = abilityMap[ability]

  if (fn) {
    return fn(permissions)
  } else {
    return false
  }
}